import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useMarkEmployeeAsBadDataQuery = (employerId?: string, onSuccess?: () => void) => {
  const { mutateAsync, isLoading, isSuccess } = useMutation(
    (newPrimaryEmployeeId?: string) =>
      api.post(API_URL.EMPLOYEES_BAD_DATA_BY_EMPLOYEE_ID(employerId || ''), {
        ...(newPrimaryEmployeeId
          ? {
              new_primary_employee_id: newPrimaryEmployeeId,
            }
          : {}),
      }),
    {
      onSuccess: () => {
        onSuccess?.();
      },
    }
  );

  return {
    markEmployeeAsBadData: mutateAsync,
    isLoading,
    isSuccess,
  };
};

export default useMarkEmployeeAsBadDataQuery;
